export default "__VITE_ASSET__SmByZJMl__"